<template>
    <div class="confirmation">

        <div class="confirmation_area" v-if="done && success">
            <div class="confirmation_div">
                <div class="confirmation_inner_div">

                    <div class="order_success_area">
                        <div class="order_success_icon success"></div>
                        <div class="order_success_message">{{label['conformation_success_header_text']}}</div>
                        <!--<div class="order_success_order_no">
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_title">{{label['conformation_success_order_no_text']}}:</div>
                                <div class="order_no_text_sign"></div>
                            </div>
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_orderno">{{orderNo}}</div>
                            </div>
                        </div>-->
                        <div class="order_success_order_no">
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_title">{{label['conformation_success_order_from_shop_text']}}:</div>
                                <div class="order_no_text_sign"></div>
                            </div>
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_orderno">{{displayShop['name'+getItemSubfix()]}}</div>
                            </div>
                        </div>

                        <div class="order_success_order_no pickup" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 2">
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_title" v-if="order.order.orderMode != 'shopping'">{{label['conformation_success_pickup_no_text']}}:</div>
                                <div class="order_no_text_title" v-if="order.order.orderMode == 'shopping'">{{label['conformation_success_pickupShop_no_text']}}:</div>
                                <div class="order_no_text_sign"></div>
                            </div>
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_pickup">{{pickUpNo}}</div>
                            </div>
                        </div>
                        <div class="order_success_order_no pickup" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 3">
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_title">{{label['conformation_success_pickupShop_no_text']}}:</div>
                                <div class="order_no_text_sign"></div>
                            </div>
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_pickup">{{pickUpNo}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="order_details_area_div">
                        <div class="order_details_area_div_1">

                            <div class="order_data_area">
                                <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 1">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['order_history_order_details_order_type_text']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                            <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(1,order.order.orderMode)}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 2">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['order_history_order_details_order_type_text']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                            <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(2,order.order.orderMode)}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 3"> <!-- only shopping have orderType 3 -->
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                            <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(3,order.order.orderMode)}}</div>
                                        </div>
                                    </div>
                                </div>

                                <!--
                                <div class="order_data_row whatsapp" v-if="$root.isWhatsApp">
                                    <div class="order_data_tag_inner_div" @click="$root.openWhatsAppMessageURL(order.order)">
                                    <div class="order_data_tag_inner_div" onclick="window.open('whatsapp://send?phone=38501410');">
                                    <a href="https://wa.me/38501410" target="_blank">
                                    <a href="nftouchuat://externalappbrowser?url=whatsapp%3A%2F%2Fsend%3Fphone%3D%2B85238501410" target="_blank" v-if="$root.NFExternalAppBrowser = 'uat'">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                        </div>
                                    </a>
                                    <a href="nftouch://externalappbrowser?url=whatsapp%3A%2F%2Fsend%3Fphone%3D%2B85238501410" target="_blank" v-if="$root.NFExternalAppBrowser != 'uat'">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="order_data_row whatsapp hotline" v-if="!$root.isWhatsApp">
                                    <a :href="'tel:'+$root.whatsappNo">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                        </div>
                                    </a>
                                </div>
                                -->
                                <!--
                                <div class="order_data_row whatsapp whatsapp" v-if="info.order_temp_info.order_device == 'ios'">
                                    <a href="https://wa.me/85238501410" target="_blank">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="order_data_row whatsapp whatsapp" v-if="info.order_temp_info.order_device != 'ios'">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}} 38501410</div>
                                        </div>
                                </div>
                                -->
                                <!--
                                <div class="order_data_row whatsapp" v-if="$root.isWhatsApp">
                                    <div class="order_data_tag_inner_div" @click="$root.openWhatsAppMessageURL(order.order)">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                    </div>
                                </div>
                                <div class="order_data_row whatsapp hotline" v-if="!$root.isWhatsApp">
                                    <a :href="'tel:'+$root.whatsappNo">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                        </div>
                                    </a>
                                </div>
                                -->
                                <div class="order_data_row delivery_date">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title" v-if="order.order.orderMode != 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 1">{{label['conformation_success_ready_datetime_text_delivery']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode != 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">{{label['conformation_success_ready_datetime_text_pickup']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 1">{{label['conformation_success_ready_datetime_shopping_text_delivery']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">{{label['conformation_success_ready_datetime_shopping_text_pickup']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3">{{label['conformation_success_ready_datetime_shopping_text_pickup']}}</div>

                                            <div class="order_data_content_a" v-if="order.order.orderMode != 'shopping'" v-html="$root.displayOrderDateTime(order.order.readyTime, true)"></div>
                                            <!--<div class="order_data_content_a" v-if="order.order.orderMode == 'shopping'" v-html="$root.displayOrderDateTime(order.order.readyTime, true, false)"></div>-->
                                            <div class="order_data_content_a" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2" v-html="label['checkout_orderType_pickup_time_text']"></div>
                                            <div class="order_data_content_a" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3" v-html="label['checkout_orderType_pickupShop_time_text']"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row online_order_no">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['conformation_success_online_order_number']}}</div>
                                            <div class="order_data_content_a">{{order.order.orderNo}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row username">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['member_profile_member_name_text']}}</div>
                                            <div class="order_data_content_a">{{order.order.name}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order_data_row phone">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['member_profile_member_tel_text']}}</div>
                                            <div class="order_data_content_a">+{{order.order.phone_countryCode}}-{{order.order.phoneHide}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row shop full" v-if="order.order.orderMode != 'shopping'">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['conformation_success_order_shop_text']}}</div>
                                            <div class="order_data_content_b">{{displayShop['name'+getItemSubfix()]}}</div>
                                            <div class="order_data_content_c">{{displayShop['address'+getItemSubfix()]}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order_data_row order_type full" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['order_mode_pickup_type_pickup_text_'+order.order.orderMode]}}</div>
                                            <div class="order_data_content_c" v-html="$root.ContentNewLineHtmlReplace(order.order['address_full_'+getItemSubfix()])"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order_data_row order_type full" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['conformation_success_order_shop_text']}}</div>
                                            <div class="order_data_content_b">{{order.order.pickupShop['name'+getItemSubfix()]}}</div>
                                            <div class="order_data_content_c">{{order.order.pickupShop['address'+getItemSubfix()]}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row address full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 1">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['conformation_success_delivery_address_header_text']}}</div>
                                            <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['conformation_success_delivery_address_header_text_shopping']}}</div>
                                            <div class="order_data_content_c" v-html="$root.ContentNewLineHtmlReplace(order.order['address_full_'+getItemSubfix()])"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row coupon full" v-if="order.order.coupons.length > 0">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['checkout_order_use_coupon_header_text']}}</div>
                                            <div class="order_data_content_a"
                                                v-for="(coup, index) in order.order.coupons">{{coup.couponName}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row coupon full" v-if="order.order.couponCode != ''">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['checkout_order_use_discount_code_header_text']}}</div>
                                            <div class="order_data_content_a">{{order.order.couponCode}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row DeliveryMessage full" v-if="$root.displayOrderDeliveryMessage(order) != ''">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['checkout_delivery_remark_text']}}</div>
                                            <div class="order_data_content_a" v-html="$root.displayOrderDeliveryMessage(order)"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row OrderRemarks full" v-if="$root.displayOrderRemarks(order) != ''">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['checkout_order_remark_text']}}</div>
                                            <div class="order_data_content_a" v-html="$root.displayOrderRemarks(order)"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_data_row delivery_date full">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">
                                            <div class="order_data_title">{{label['conformation_success_create_datetime_text']}}</div>
                                            <div class="order_data_content_a">{{$root.orderDateTimeDisplay(order.order.orderDate)}}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="order_details_area_div_2">

                            <div class="order_items_area">
                                <div class="order_items_list_header">{{label['conformation_success_order_data_header_text']}}</div>
                                <div class="order_items_list_area">                    
                            
                                    <CartListItem v-bind:cart="order.order" v-bind:can_update="false">
                                    </CartListItem>
                            
                                </div>
                            </div>

                            <div class="order_payment_area" v-if="order.order.payments != undefined && order.order.payments.length > 0">
                                <div class="order_payment_area_header">{{label['checkout_payment_method_header_text']}}</div>
                                <div class="order_payment_area_content">
                                    <div class="order_payment_text">
                                        <div class="text_div">{{ getPayMethodObj(order.order.payments[0])["name" + getItemSubfix()] }}</div>
                                        <div class="icon_div master_card" v-if="getPayMethodObj(order.order.payments[0])['code'] == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                        <div class="icon_div visa_card" v-if="getPayMethodObj(order.order.payments[0])['code'] == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                    </div>
                                    <div class="order_payment_icon" :style="{'background-image':'url(\''+getPayMethodObj(order.order.payments[0])['image']+'\')'}"></div>
                                </div>
                            </div>

                            <div class="order_amount_area">

                                <div class="order_amount_row">
                                    <div class="price_text">{{label['amount_label']}}</div>
                                    <div class="price_amount">
                                        <!--<money :price="$root.sumItemListPrice(order.order.items)" />-->
                                        <money :price="order.order.amountWithoutDiscount" />
                                    </div>
                                </div>

                                <div class="order_amount_row isAlert" v-if="order.order.minCharge > 0">
                                    <div class="price_text">{{label['cart_fit_minCharge_text']}}</div>
                                    <div class="price_amount">
                                        <money :price="order.order.minCharge" />
                                    </div>
                                </div>

                                <div class="order_amount_row" v-if="order.order.packingCharge > 0">
                                    <div class="price_text">{{label['cart_packingCharge_text']}}</div>
                                    <div class="price_amount">
                                        <money :price="order.order.packingCharge" />
                                    </div>
                                </div>                                

                                <!-- load discount item start -->
                                <div class="order_amount_row"
                                        v-for="(discount, index) in order.order.discounts.filter(x => !x.isHide)"
                                        :key="'d'+index">
                                    <div class="price_text">{{discount['name'+getItemSubfix()]}}</div>
                                    <div class="price_amount">
                                        -<money :price="discount.price" />
                                    </div>
                                </div>
                                <!-- load discount item end -->

                                <div class="order_amount_row" v-if="order.order.deliveryCharge > 0">
                                    <div class="price_text">{{label['cart_deliveryCharge_text']}}</div>
                                    <div class="price_amount">
                                        <money :price="order.order.deliveryCharge" />
                                    </div>
                                </div>

                                <div class="order_amount_row" v-if="order.order.usedECash > 0">
                                    <div class="price_text">{{label['checkout_order_use_ecash_text_used_ecash']}}</div>
                                    <div class="price_amount">
                                        -<money :price="order.order.usedECash" />
                                    </div>
                                </div>

                                <div class="order_amount_row final_amount">                                    
                                    <div class="price_text">{{label['total_amount_need_pay_label']}}</div>
                                    <div class="price_amount">
                                        <money :price="order.order.amount" />
                                    </div>
                                </div>
               
                            </div>

                            <div class="order_amount_area no_border">

                                <div class="order_amount_row final_amount">
                                    <div class="price_text">{{label['total_amount_label']}}</div>
                                    <div class="price_amount">
                                        <money :price="order.order.amount" />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div class="page_bottom_btn_div">
                        <div class="bottom_btn active" @click="exit()">{{label['conformation_success_back_home_btn_text']}}</div>
                    </div>

                </div>
            </div>
        </div>


        <div class="confirmation_area" v-if="done && !success">
            <div class="confirmation_div">
                <div class="confirmation_inner_div">

                    <div class="order_success_area">
                        <div class="order_success_icon fail"></div>
                        <div class="order_success_message" v-html="fail_message"></div>
                        <div class="order_success_order_no" v-if="(orderNo != null && orderNo != '')">
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_title">{{label['conformation_success_order_no_text']}}:</div>
                                <div class="order_no_text_sign"></div>
                            </div>
                            <div class="order_success_order_no_row">
                                <div class="order_no_text_orderno">{{orderNo}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="page_bottom_btn_div no_border">
                        <div class="bottom_btn active" @click="goBack()">{{label['conformation_fail_back_home_btn_text']}}</div>
                    </div>

                </div>
            </div>
        </div>


    </div>
</template>
 
<script>
    import CartListItem from "../components/CartListItem.vue";

    export default {
        data() {
            return {
                done: false,
                success: false,
                order: undefined,
                orderNo: "",
                confirmAction: "",
                retry: 0,

                displayShop: null,

				checkOrderUrl: "/order/SubmitOrderCheck",

                payMethodList: [
                    {
                        code: "-1",
                        name1: "",
                        name2: "",
                        name3: "",
                        image: ""
                    }
                ],

                fail_message:"",
                reasonCode_bankReject: ["201", "203", "204", "205", "208", "210", "211"]
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            },
            orderNumberA() {
                return (this.orderNo != null && this.orderNo != "") ? this.orderNo.substring(0, this.orderNo.length - 5) : "";
            },
            orderNumberB() {
                return (this.orderNo != null && this.orderNo != "") ? this.orderNo.substring(this.orderNo.length - 5) : "";
            },
            orderNumberA2() {
                return (this.orderNo != null && this.orderNo != "") ? this.orderNo.substring(0, this.orderNo.length - 5) : "";
            },
            orderNumberB2() {
                return (this.orderNo != null && this.orderNo != "") ? this.orderNo.substring(this.orderNo.length - 5) : "";
            },  
            pickUpNo() {
                //return (this.orderNo != null && this.orderNo != "") ? this.orderNo.substring(this.orderNo.length - 4) : "";
                return (this.order != undefined && this.order != null && this.order.order != null) ? this.order.order.pickUpNo : "";
            },  
        },
        components: { CartListItem },
        created() {
            this.GetPayMethodList();

            // prevent cannot scroll when loading the page
            this.$root.setBodyOverflow(false);
            this.info.itemMenuDetailsOpen = false;

            this.info.loading = false;

            this.info.canGoBack = false;
            this.$root.getCurrentPathName();

            if (this.info.orderResult) this.showResult();
            else {
                var app = this;
                app.orderNo = this.$root.getParameterByName("orderNo");
                app.confirmAction = this.$root.getParameterByName("confirmAction");
                if ((app.orderNo || "") == "") {                    
                    this.showResult();
                    return;
                }
                window.history.replaceState(null, null, this.info.currentPathName);
                app.info.loading = true;
                //app.getOrderResult();
                setTimeout(app.getOrderResult, 1000);
            }
        },
        destroyed() {
            this.$root.setGoBackAction();
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },            

            getOrderResult() {
                var app = this;
                app.retry++;
                app.$root
                    .wsPost(
                        this.info.wsUrl + app.checkOrderUrl,
                        this.lang,
                        JSON.stringify({
                            data: {
                                //orderNo: app.orderNo,
                                paymentNo: app.orderNo
                            },
                        }),
                        (data) => {
                            console.log("getOrderResult", data);
                            const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";

                            //var exit = app.retry > 10;
                            //var exit = app.retry > 15; // updated to 15 on 2025-12-05
                            //var exit = app.retry > 5; // updated to 5 on 2026-09-01 (5 * 2s = about 10s)
                            var exit = app.retry > 9; // updated to 9 on 2026-09-02 (9 * 2s = about 18s)
							if (app.retry > 6) { // change checking url when checking fail few times
                              app.checkOrderUrl = "/order/SubmitOrder";
							}
                            if (app.confirmAction == "cancel") {
                                //exit = app.retry >= 1;
                                exit = app.retry >= 3; // updated to 3 on 2025-12-05, change back to 3 on 2026-09-02
                                //exit = app.retry >= 2; // updated to 2 on 2026-09-01
                                if (app.retry > 1) {
                                  app.checkOrderUrl = "/order/SubmitOrder";
                                }
                            }
                            var isContinue = true;

                            if (data.status == 0) {
                                app.info.orderResult = data;
                                if (data.sent == true) exit = true;
                            } else {

                                if (data_msg == "order.sent") {
                                    if (app.cart.memberCode == data.order.memberCode) {
                                        app.info.orderResult = data;
                                        exit = true;
                                    }
                                    else {
                                        isContinue = false;
                                        //this.$router.replace("/member/orderhistory/" + data.order.orderNo);
                                        this.$router.replace("/member/orderhistory");
                                    }
                                }
                                else if (data_msg == "order.cancel") {
                                    exit = true;
                                } else {
                                    if (data.exit == true) exit = true;
                                    if (exit) app.$root.alert(data.message);
                                }                                
                            }

                            if (isContinue) {
                                if (exit) {
                                    app.info.loading = false;
                                    app.showResult();
                                } else {
                                    //setTimeout(app.getOrderResult, 1000);
									setTimeout(app.getOrderResult, 2000); // updated to 2000 on 2025-12-05
                                }
                            }
                        }
                    )
                    .always(() => { })
                    .fail(() => {
                        //alert("Fail!");
                        app.$root.alert("common_fail_message");
                    });
            },

            showResult() {
                this.done = true;

                if (this.info.orderResult) {
                    this.success = this.info.orderResult.sent == true;                    
                    if (this.info.orderResult.order)
                        this.orderNo = this.info.orderResult.order.orderNo;

                    this.order = JSON.parse(JSON.stringify(this.info.orderResult));
                    this.info.orderResult = undefined;
                }
                console.log("this.order", this.order);

                if (this.success) {
                    //console.log("this.order", this.order);
                    this.$root.removeOrderData(); // clear info.order when success payment

                    // ga start
                    if (typeof WebOnGAObj != 'undefined') {
                        //RunTransactionGA(this.order.order);
                    }
                    // ga end

                    this.displayShop = this.$root.getShopInfo(this.order.order.shop.shopCode);

                    // clear data
                    this.$root.clearAllStoreData();

                    //this.info.canGoBack = false;

                    if (this.order.order.memberId == undefined || this.order.order.memberId == null || this.order.order.memberId != "") {
                        var orders = JSON.parse(window.localStorage.getItem("orders") || "[]");
                        if (
                            !orders.find((o) => o.orderNo == this.order.order.orderNo)
                        ) {
                            orders.unshift(this.order.order);
                            window.localStorage.setItem("orders", JSON.stringify(orders));
                        }
                    }
                    
                } else {
                    this.$root
                        .wsPost(
                            this.info.wsUrl + "/order/cancelorder",
                            this.lang,
                            JSON.stringify({
                                data: {
                                    orderNo: this.orderNo,
                                },
                            }),
                            (data) => { }
                        )
                        .fail(() => { });
                    this.$root.setGoBackAction(this.goBack);
                    /*
                    if (this.order != undefined && this.order.order.payments != undefined && this.order.order.payments.length > 0) {
                        if (this.order.order.payments[0].code == "cybersource") {
                            var reasonCode = this.order.reasonCode == undefined ? "-1" : this.order.reasonCode;
                            if (reasonCode_bankReject.indexOf(reasonCode) >= 0) {
                                this.fail_message = this.label['conformation_fail_header_text_blank_reject'];
                            } else {
                                this.fail_message = this.label['conformation_fail_header_text'];
                            }
                        }
                        else {
                            this.fail_message = this.label['conformation_fail_header_text'];
                        }
                    } else {
                        this.fail_message = this.label['conformation_fail_header_text'];
                    }
                    */
                    if (this.order != undefined) {

                        var reasonCode = this.order.reasonCode == undefined ? "-1" : this.order.reasonCode;
                        if (this.reasonCode_bankReject.indexOf(reasonCode) >= 0) {
                            this.fail_message = this.label['conformation_fail_header_text_blank_reject'];
                        } else {
                            this.fail_message = this.label['conformation_fail_header_text'];
                        }
    
                    } else {
                        this.fail_message = this.label['conformation_fail_header_text'];
                    }

                    // clear data
                    this.$root.clearAllStoreData();
                }
            },

            exit() {
                if (this.$root.finishAction) {
                    eval(this.$root.finishAction);
                    return;
                } else if (this.$root.exitAction) {
                    eval(this.$root.exitAction);
                    return;
                }
                this.$router.replace("/");
            },
            goBack() {
                this.$router.replace("/");
                return true;
            },

            GetPayMethodList() {                
                $.get(
                    "/files/payMethod.json",
                    data => {
                        this.payMethodList = data.list;
                    },
                    "JSON"
                );            
            },
            getPayMethodObj(method_obj) {
                var m = this.payMethodList.filter(a => a.code == method_obj.code);
                if (m.length > 0) {
                    return m[0];
                }
                else {
                    return method_obj
                }
            },

        },
    };
</script>

